<p class="global-red">{{ thankYouMessage }}</p>
<p>Your form is locked from editing and you can't make changes to the information already provided.</p>
<p>Please click below to view your submitted applicant form.
</p>

<div>
  <button type="button" class="bofa--button secondary outlined" title="Download Applicant Form PDF"
  (click)="generatePDF()">Download Applicant Form PDF</button>
</div>

@if (!this.nhpToken || nhpToken=='undefined') {
  <p>You may also view form.
    <a class="mat-list-item" href="registration?verifyId={{ verifyId }}">Click here to login</a>
  </p>
}